/* Potifiv Email Guard v1.2 (2026-08-04)
   Catches mistyped email domains on storefront forms before submit.
   - Suggests a correction for near-miss domains ("Did you mean gmail.com?")
   - Blocks submission when the TLD is a dead near-miss of a real one (.coml, .comw, .coms)
   Does NOT touch checkout (Shopify-controlled, Basic plan).
   No dependencies. Attaches to every input[type="email"] on the page. */
(function () {
  'use strict';

  var COMMON_DOMAINS = [
    'gmail.com','googlemail.com','yahoo.com','ymail.com','rocketmail.com',
    'hotmail.com','outlook.com','live.com','msn.com','icloud.com','me.com','mac.com',
    'aol.com','protonmail.com','proton.me','gmx.com','gmx.net','mail.com','zoho.com',
    'comcast.net','bellsouth.net','sbcglobal.net','verizon.net','att.net','cox.net',
    'charter.net','earthlink.net','roadrunner.com','optonline.net','frontier.com',
    'yahoo.co.uk','hotmail.co.uk','outlook.co.uk','live.co.uk','btinternet.com',
    'sky.com','virginmedia.com','talktalk.net','ntlworld.com',
    'yahoo.ca','hotmail.ca','shaw.ca','rogers.com','sympatico.ca','telus.net',
    'yahoo.com.au','hotmail.com.au','bigpond.com','optusnet.com.au','iinet.net.au',
    'web.de','gmx.de','t-online.de','freenet.de','yahoo.de','hotmail.de',
    'orange.fr','wanadoo.fr','free.fr','laposte.net','yahoo.fr','hotmail.fr',
    'libero.it','virgilio.it','alice.it','yahoo.it','hotmail.it',
    'yahoo.co.jp','naver.com','qq.com','163.com','126.com','singnet.com.sg'
  ];

  /* TLDs treated as real. If a TLD is in here it is never blocked. */
  var VALID_TLDS = ('com net org edu gov mil int io co ai app dev me tv cc biz info name pro ' +
    'xyz online site tech store shop blog live life world email cloud page link ' +
    'us uk ca au nz de fr it es nl be ch at se no dk fi is pl pt gr ie cz sk hu ro bg hr si ' +
    'ru ua by lt lv ee jp cn kr in sg my th ph id hk tw vn bd pk lk np ' +
    'br mx ar cl pe co ve uy py bo ec cr pa gt do cu ' +
    'za ng ke gh tz ug zw ma dz tn eg il ae sa qa kw bh om jo lb tr ir iq ' +
    'eu asia africa').split(' ');

  /* Two-part suffixes we recognise as a unit. */
  var VALID_SUFFIXES = ('co.uk org.uk me.uk ac.uk gov.uk net.uk ltd.uk plc.uk ' +
    'com.au net.au org.au edu.au gov.au id.au ' +
    'co.nz net.nz org.nz co.za org.za co.jp or.jp ne.jp ' +
    'co.kr com.sg com.my co.th com.ph co.id com.hk com.tw com.vn co.in net.in org.in ' +
    'com.br net.br com.mx com.ar com.co com.pe com.tr com.eg com.sa com.ng').split(' ');

  /* Distinctive provider names. Used only for the substring fallback below. */
  var PROVIDER_LABELS = [
    ['gmail','gmail.com'], ['yahoo','yahoo.com'], ['hotmail','hotmail.com'],
    ['outlook','outlook.com'], ['icloud','icloud.com'], ['comcast','comcast.net'],
    ['bellsouth','bellsouth.net'], ['sbcglobal','sbcglobal.net'], ['btinternet','btinternet.com']
  ];

  /* TLDs common enough that a near-miss is almost certainly a typo. */
  var COMMON_TLDS = ['com','net','org','edu','gov','uk','ca','au','de','fr','it','es','nz','jp','in'];

  /* Restricted Damerau-Levenshtein: counts a transposition as one edit,
     so .ocm / .cmo / .nte register as single-character typos. */
  function lev(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length;
    if (!m) return n;
    if (!n) return m;
    var d = [], i, j;
    for (i = 0; i <= m; i++) { d[i] = [i]; }
    for (j = 0; j <= n; j++) { d[0][j] = j; }
    for (i = 1; i <= m; i++) {
      for (j = 1; j <= n; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 &&
            a.charAt(i - 1) === b.charAt(j - 2) &&
            a.charAt(i - 2) === b.charAt(j - 1)) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
      }
    }
    return d[m][n];
  }

  function suffixOf(domain) {
    var parts = domain.split('.');
    if (parts.length >= 3) {
      var last2 = parts.slice(-2).join('.');
      if (VALID_SUFFIXES.indexOf(last2) !== -1) return last2;
    }
    return parts[parts.length - 1];
  }

  /* Returns null (ok), or {type:'block'|'suggest', suggestion:'...'} */
  function inspect(value) {
    var v = String(value || '').trim().toLowerCase();
    if (!v) return null;
    var at = v.lastIndexOf('@');
    if (at < 1 || at === v.length - 1) return null; /* let native validation handle shape */
    var domain = v.slice(at + 1);
    var local = v.slice(0, at);
    if (domain.indexOf('.') === -1) return null;

    /* Exact match on a known provider is always fine. */
    if (COMMON_DOMAINS.indexOf(domain) !== -1) return null;

    var suffix = suffixOf(domain);
    var isKnownSuffix = VALID_SUFFIXES.indexOf(suffix) !== -1 || VALID_TLDS.indexOf(suffix) !== -1;

    /* Dead-TLD check: unknown suffix that is one edit away from a very common one. */
    if (!isKnownSuffix) {
      for (var t = 0; t < COMMON_TLDS.length; t++) {
        if (lev(suffix, COMMON_TLDS[t]) === 1) {
          var fixedDomain = domain.slice(0, domain.length - suffix.length) + COMMON_TLDS[t];
          return { type: 'block', suggestion: local + '@' + fixedDomain };
        }
      }
      return null; /* unknown but not a near-miss: could be a legitimate rare TLD, leave alone */
    }

    /* Domain suggestion: near-miss of a known provider. */
    var best = null, bestD = 99;
    for (var i = 0; i < COMMON_DOMAINS.length; i++) {
      var d = lev(domain, COMMON_DOMAINS[i]);
      if (d < bestD) { bestD = d; best = COMMON_DOMAINS[i]; }
    }
    var limit = domain.length <= 8 ? 1 : 2;
    if (best && bestD > 0 && bestD <= limit) {
      return { type: 'suggest', suggestion: local + '@' + best };
    }

    /* Mangled-provider fallback: the label swallows a known provider name
       (e.g. "bsugmail.net" contains "gmail"). Suggestion only, never a block. */
    var label = domain.slice(0, domain.length - suffix.length - 1);
    for (var p = 0; p < PROVIDER_LABELS.length; p++) {
      var name = PROVIDER_LABELS[p][0];
      if (label !== name && label.length > name.length && label.indexOf(name) !== -1) {
        return { type: 'suggest', suggestion: local + '@' + PROVIDER_LABELS[p][1] };
      }
    }
    return null;
  }

  /* ---------- styles (self-contained, does not touch potifiv-overrides.css) ---------- */

  function injectStyles() {
    if (document.getElementById('ptv-eg-styles')) return;
    var s = document.createElement('style');
    s.id = 'ptv-eg-styles';
    s.textContent =
      '.ptv-eg-note{font-family:"JetBrains Mono",ui-monospace,monospace;font-size:12px;' +
      'line-height:1.4;margin-top:6px;letter-spacing:.02em;}' +
      '.ptv-eg-note:empty{display:none;}' +
      '.ptv-eg-note.is-suggest{color:#8B8680;}' +
      '.ptv-eg-note.is-block{color:#E8743C;}' +
      '.ptv-eg-fix{background:none;border:0;padding:0;margin:0;font:inherit;color:#E8743C;' +
      'text-decoration:underline;text-underline-offset:2px;cursor:pointer;}' +
      '.ptv-eg-fix:hover{opacity:.75;}' +
      /* the note may land inside a flex/grid row (Dawn wraps inputs in .field),
         so force it onto its own full-width line rather than beside the input */
      '.ptv-eg-note{display:block;width:100%;flex:0 0 100%;}';
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectStyles);
  } else {
    injectStyles();
  }

  /* ---------- UI ---------- */

  /* Where to hang the message. Dawn wraps the input in a display:flex .field
     alongside the submit button, so anchoring to the input itself puts the note
     INSIDE the input box. Climb out of any flex/grid row first. */
  function anchorFor(input) {
    var a = input.closest ? input.closest('.field') : null;
    if (a && a.parentNode) return a;
    a = input;
    var p = a.parentNode;
    while (p && p.nodeType === 1) {
      var disp = getComputedStyle(p).display;
      if (disp !== 'flex' && disp !== 'inline-flex' && disp !== 'grid' && disp !== 'inline-grid') break;
      a = p;
      p = a.parentNode;
    }
    return a;
  }

  function noteFor(input) {
    var note = input.__ptvNote;
    if (note && note.isConnected) return note;
    note = document.createElement('div');
    note.className = 'ptv-eg-note';
    note.setAttribute('aria-live', 'polite');
    var anchor = anchorFor(input);
    var parent = anchor.parentNode;
    /* In a grid (Dawn's .contact__fields is 2-col) a full-width note would land
       under the WRONG field, so pin it to the anchor's own column. */
    var col = 0;
    var pcs = getComputedStyle(parent);
    if (pcs.display === 'grid' || pcs.display === 'inline-grid') {
      var tracks = pcs.gridTemplateColumns.split(' ').filter(Boolean).length;
      if (tracks > 1) {
        var idx = Array.prototype.indexOf.call(parent.children, anchor);
        if (idx >= 0) col = (idx % tracks) + 1;
      }
    }
    if (anchor.nextSibling) parent.insertBefore(note, anchor.nextSibling);
    else parent.appendChild(note);
    if (col) note.style.gridColumn = String(col);
    input.__ptvNote = note;
    return note;
  }

  function clear(input) {
    input.removeAttribute('data-ptv-block');
    var note = input.__ptvNote;
    if (note && note.isConnected) { note.textContent = ''; note.className = 'ptv-eg-note'; }
  }

  function render(input, result) {
    clear(input);
    if (!result) return;
    var note = noteFor(input);
    note.className = 'ptv-eg-note is-' + result.type;

    var label = document.createElement('span');
    label.textContent = result.type === 'block'
      ? 'That address will not deliver. Did you mean '
      : 'Did you mean ';
    note.appendChild(label);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ptv-eg-fix';
    btn.textContent = result.suggestion;
    btn.addEventListener('click', function () {
      input.value = result.suggestion;
      clear(input);
      input.focus();
    });
    note.appendChild(btn);
    note.appendChild(document.createTextNode('?'));

    if (result.type === 'block') input.setAttribute('data-ptv-block', '1');
  }

  function check(input) {
    render(input, inspect(input.value));
  }

  /* ---------- wiring ---------- */

  document.addEventListener('blur', function (e) {
    var el = e.target;
    if (el && el.tagName === 'INPUT' && el.type === 'email') check(el);
  }, true);

  document.addEventListener('input', function (e) {
    var el = e.target;
    if (el && el.tagName === 'INPUT' && el.type === 'email' && el.hasAttribute('data-ptv-block')) clear(el);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelectorAll) return;
    var emails = form.querySelectorAll('input[type="email"]');
    for (var i = 0; i < emails.length; i++) {
      var res = inspect(emails[i].value);
      render(emails[i], res);
      if (res && res.type === 'block') {
        e.preventDefault();
        e.stopPropagation();
        emails[i].focus();
        return;
      }
    }
  }, true);
})();
